<template>
  <ReviewCollectionPopup
    v-if="isAuthorized"
    :order="popupOrder"
    :is-shown="isPopupOpen"
    :is-submitting="isSubmittingRating"
    @close="closePopup"
    @rate="onPopupRate"
  />
</template>

<script setup lang="ts">
import { usePendingReviews } from '@/entities/pending-review/composables/usePendingReviews';

import ReviewCollectionPopup from './ReviewCollectionPopup.vue';

const { isAuthorized, popupOrder, isPopupOpen, isSubmittingRating, closePopup, submitRating } = usePendingReviews();

const onPopupRate = async (rate: number) => {
  if (!popupOrder.value) {
    return;
  }

  await submitRating(popupOrder.value, rate);
};
</script>
